import type {ReactNode} from 'react';
import React from 'react';
import {Box} from '@tempo/core';
import Footer from '@layouts/Footer';
import Header from '@layouts/Header';

type Props = {
	children?: ReactNode;
};

const Layout: React.FC<Props> = ({children}) => (
	<Box padding="spacing.l">
		<Header />
		{children}
		<Footer />
	</Box>
);

export default Layout;
